import { render, staticRenderFns } from "./MessageConfirm.vue?vue&type=template&id=1aa49773&"
import script from "./MessageConfirm.vue?vue&type=script&lang=js&"
export * from "./MessageConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports